import { useTranslations } from "contexts/LocalizationContext";
import { CheckmarkThickIcon } from "styles/icons";
import {
  ChakraHeading as Heading,
  ChakraListItem as ListItem,
  ChakraListIcon as ListIcon,
  ChakraVStack as VStack,
  ChakraText as Text,
} from "@airhelp/react-ui-components";
import type { ListItemProps } from "./WhyChooseAirHelp.d";

const PositiveItem = ({ item }: ListItemProps) => {
  const translations = useTranslations();

  return (
    <ListItem
      display="flex"
      flexDirection={{ base: "column", md: "row" }}
      background="white"
      p={{ base: 8, md: 0 }}
      rounded={{ base: "xl", md: "none" }}
      minWidth="255px"
    >
      <ListIcon as={CheckmarkThickIcon} color="success.600" boxSize={6} mt={1} />
      <VStack spacing={2} align="left" mt={{ base: 6, md: 0 }}>
        <Heading variant="h5" as="h5" fontWeight={{ base: "500", md: "700" }}>
          {translations(item.headingTranslationKey)}
        </Heading>
        <Text fontSize="md">{translations(item.textTranslationKey)}</Text>
      </VStack>
    </ListItem>
  );
};

export default PositiveItem;
